import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormService } from 'src/app/core/form.service';
import { Seller, SellerMfaType, SellersService } from 'src/app/core/sellers.service';

@Component({
  selector: 'app-sellers-set-mfa-dialog',
  templateUrl: './sellers-set-mfa-dialog.component.html',
  styleUrls: ['./sellers-set-mfa-dialog.component.scss'],
})
export class SellersSetMfaDialogComponent {
  seller?: Seller;
  reset_mfa_form_group: FormGroup = this.form_service.reset_mfa_form_group;
  sellers_mfa_type = SellerMfaType;
  is_seller_edit_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<SellersSetMfaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private form_service: FormService,
    private sellers_service: SellersService,
    private error_service: ErrorService,
  ) {
    this.seller = data.seller;
  }

  ngOnInit(): void {
    if (this.seller?.preferred_mfa === SellerMfaType.totp) {
      this.reset_mfa_form_group.get(this.form_service.type_label)?.setValue(SellerMfaType.totp);
    } else {
      this.reset_mfa_form_group.get(this.form_service.type_label)?.setValue(SellerMfaType.sms);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid() && !this.is_seller_edit_running) {
      const type = this.reset_mfa_form_group.get(this.form_service.type_label)?.value;
      this.resetMFA(this.seller?.seller_id as string, type);
    }
  }

  resetMFA(seller_id: string, type: SellerMfaType): void {
    this.is_seller_edit_running = true;
    this.sellers_service.setMfa(seller_id, type).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_seller_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_seller_edit_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.reset_mfa_form_group);
  }

  getTruncatedEmail(): string | undefined {
    const index = this.seller?.email.indexOf('@');
    if (index != -1) {
      return this.seller?.email.substring(0, index);
    }
    return this.seller?.email;
  }
}
